export default "__VITE_ASSET__D8gqEEv6__"